import { render, staticRenderFns } from "./fdeclaredetail.vue?vue&type=template&id=56ca1070&scoped=true"
import script from "./fdeclaredetail.vue?vue&type=script&lang=js"
export * from "./fdeclaredetail.vue?vue&type=script&lang=js"
import style0 from "./fdeclaredetail.vue?vue&type=style&index=0&id=56ca1070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca1070",
  null
  
)

export default component.exports